import React from "react"
import { Dimmer, Loader as LoaderSemantic } from "semantic-ui-react"
import { useParams } from "react-router-dom"
//import useRouter from "../../hooks/useRouter"

type Props = {
  active: boolean
}

const Loader = ({
  active
}: Props) => {
  //const router = useRouter() as any
  let { token, lang, id } = useParams();

  return (
    <Dimmer active={active} inverted>
      <LoaderSemantic inverted content={(lang === 'FR') ? 'Chargement' : 'Loading'} />
    </Dimmer>
  )
}

export default Loader